export default class GoogleAnalyticsEventAction {
  static get DirectLeads() {
    return this.getInstance('Direct Leads');
  }

  static get NonDirectLeads() {
    return this.getInstance('RCL NonDirect leads');
  }

  static get Leads() {
    return this.getInstance('Leads');
  }

  static fromKey(key) {
    const statusMap = {
      R: GoogleAnalyticsEventAction.DirectLeads,
      A: GoogleAnalyticsEventAction.Leads,
      'RCL NonDirect leads': GoogleAnalyticsEventAction.NonDirectLeads,
    };
    return statusMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new GoogleAnalyticsEventAction(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(GoogleAnalyticsEventAction, 'instances', { value: {} });
